module.exports = __webpack_public_path__ + "static/media/corona.7b38f5d4.gif";